module.exports = __webpack_public_path__ + "b96e5c677df2a1292d2c02cfc88ea756.webp";